//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageSearchHeader from "../componets/page-search-header";
import WorkOrderCell from "../componets/work-order-cell";

export default {
    name: "repairs",
    components: {WorkOrderCell, PageSearchHeader},
    data() {
        return {
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            searchInput: {}
        }
    },
    props: {
        status: {
            type: Number,
            required: true
        }
    },
    methods: {
        workDetail(item) {
            this.$router.push({
                name: 'workSheetDetail',
                params: {
                    id: item.id
                }
            })
        },
        onRefresh() {
            this.pageIndex = 1;
            this.getWorkOrders();
        },
        onLoad() {
            this.pageIndex++;
            this.getWorkOrders()
        },
        getWorkOrders() {
            const vm = this;
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            // var page = {
            //     maxResultCount: this.pageSize,
            //     skipCount: (this.pageIndex - 1) * this.pageSize,
            //     status: this.status,
            //     workOrderType: 2,
            // };

            this.searchInput.workOrderType = 2;
            this.searchInput.status = this.status;
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.pageIndex - 1) * this.pageSize

            abp.ajax.post('/api/services/app/MicroWorkOrder/SearchWorkOrders', this.searchInput).then((res) => {
                if (this.pageIndex === 1) {
                    vm.list = [];
                }
                vm.list.push(...res.data.result.items);
                // console.log(this.list);
                if (res.data.result.items.length < this.pageSize) {
                    vm.finished = true;
                } else {
                    vm.finished = false;
                }
            }).then(() => {
                vm.refreshing = false;
                vm.loading = false;
            }).catch((error) => {
                vm.refreshing = false;
                vm.loading = true;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },

        handleSearch(data) {
            this.searchInput = data;
            this.onRefresh();
        },
    },
    created() {

    }
}
